export interface MeshTopologyNode {
  hostname: string;
  tailscaleIp: string;
  servicesExposed: string[];
  latencyMs: number;
  status: 'ONLINE' | 'OFFLINE';
}

export interface WorkspaceMember {
  id: string;
  name: string;
  didKey: string;
  role: 'admin' | 'user' | 'guest';
  status: 'Online' | 'Offline' | 'Pending Auth';
  avatarUrl: string;
  isSelf?: boolean;
}

export interface WorkspaceLayoutState {
  currentRoom: string;
  isSidebarOpen: boolean;
  topPaneHeight: number;
  streamingAllowed: boolean;
  activeMedia: {
    video: boolean;
    audio: boolean;
    screen: boolean;
    broadcast: boolean;
    whiteboard: boolean;
    agents: boolean;
  };
}

export class WorkspaceStore {
  private layout: WorkspaceLayoutState = {
    currentRoom: 'general',
    isSidebarOpen: true,
    topPaneHeight: 320,
    streamingAllowed: true,
    activeMedia: {
      video: false,
      audio: false,
      screen: false,
      broadcast: false,
      whiteboard: false,
      agents: false,
    },
  };

  private members: WorkspaceMember[] = [
    {
      id: 'admin2',
      name: 'admin2',
      didKey: 'hns://admin2.019fe1b3-68e4-7531-ad51-747c930ed436.hns-electron',
      role: 'admin',
      status: 'Pending Auth',
      avatarUrl: 'https://ui-avatars.com/api/?name=admin2&background=random',
      isSelf: true,
    },
  ];

  private topologyNodes: MeshTopologyNode[] = [
    { hostname: 'admin2 (Local)', tailscaleIp: 'device_laptop', servicesExposed: ['UI Client', 'Pending Auth'], latencyMs: 0, status: 'ONLINE' },
    { hostname: 'HerxPc', tailscaleIp: '100.113.15.51', servicesExposed: ['Idle'], latencyMs: 0, status: 'OFFLINE' },
    { hostname: 'sovereign-gateway', tailscaleIp: '100.74.155.71', servicesExposed: ['Idle'], latencyMs: 0, status: 'OFFLINE' },
    { hostname: 'Ella-PC', tailscaleIp: '100.109.34.11', servicesExposed: ['Idle'], latencyMs: 0, status: 'OFFLINE' },
    { hostname: 'herxair', tailscaleIp: '100.81.52.0', servicesExposed: ['Idle'], latencyMs: 0, status: 'OFFLINE' },
  ];

  getLayout(): WorkspaceLayoutState {
    return { ...this.layout, activeMedia: { ...this.layout.activeMedia } };
  }

  updateLayout(patch: Partial<WorkspaceLayoutState>): WorkspaceLayoutState {
    this.layout = {
      ...this.layout,
      ...patch,
      activeMedia: patch.activeMedia ? { ...this.layout.activeMedia, ...patch.activeMedia } : this.layout.activeMedia,
    };
    return this.getLayout();
  }

  toggleStreamingAllowed(): boolean {
    this.layout.streamingAllowed = !this.layout.streamingAllowed;
    return this.layout.streamingAllowed;
  }

  getMembers(): WorkspaceMember[] {
    return [...this.members];
  }

  getTopologyNodes(): MeshTopologyNode[] {
    return [...this.topologyNodes];
  }
}

export const globalWorkspaceStore = new WorkspaceStore();
